import { useTranslation } from 'react-i18next'
import { InvoiceStatus as InvoiceStatusType } from 'shared/types'
import { Dot, Container } from './InvoiceStatus.style'
import { determineDotColor } from './InvoiceStatus.utils'

interface InvoiceStatusProps {
  status: InvoiceStatusType
}

const InvoiceStatus = ({ status }: InvoiceStatusProps) => {
  const { t } = useTranslation()
  return (
    <Container>
      <Dot color={determineDotColor(status)} />
      {t(`invoiceStatus.${status}`)}
    </Container>
  )
}

export default InvoiceStatus
